import axios from "axios";
import { v4 } from "uuid";

export interface BlogPost {
    id: string;
    title: string;
    content: string;
    createdAt: string; // time.DateTime
    tags: string;
}

export const getAllBlogPosts = async () : Promise<BlogPost[]> => {
    const response = await axios.get(process.env.REACT_APP_API_URL + '/v1/blog', {
        headers: {
            'X-Request-ID': v4()
        }
    });

    if (response.status !== 200) {
        throw new Error('Failed to fetch blog posts');
    }

    return response.data as BlogPost[];
}

export const createBlogPost = async () : Promise<string> => {
    const response = await axios.post(process.env.REACT_APP_API_URL + '/v1/blog', {
        headers: {
            'X-Request-ID': v4()
        }
    });

    if (response.status !== 200) {
        throw new Error('Failed to create blog post');
    }

    return response.data.id as string;
}
